import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: (string | undefined | null | false)[]) {
  return twMerge(clsx(inputs));
}

// Export validation utilities
export * from './validation';

// Export sanitization utilities
export * from './sanitization';

// Export date utilities
export * from './dateUtils';